import type { ReactElement } from 'react';
import { isValidElement } from 'react';
import { isMessageRef, type MessageRef } from '@gonfalon/messages/ref';
import { z } from 'zod';

const reactElementSchema = z.custom<ReactElement>((val) => isValidElement(val), {
  message: 'Expected a React element',
});

const breadcrumbReturnSchema = z.union([z.string(), reactElementSchema, z.null(), z.undefined()]);

const breadcrumbFunctionSchema = z.function({
  input: [z.custom<{ data: unknown }>()],
  output: breadcrumbReturnSchema,
});

const messageRefSchema = z.custom<MessageRef>(isMessageRef);

const breadcrumbValueSchema = z.union([z.string(), messageRefSchema, breadcrumbFunctionSchema, reactElementSchema]);

export type BreadcrumbValue = z.infer<typeof breadcrumbValueSchema>;

export const breadcrumbSchema = z.object({ breadcrumb: breadcrumbValueSchema });

export const flatSettingsBreadcrumbSchema = z.object({
  flatSettings: z.object({
    breadcrumb: breadcrumbValueSchema,
    scope: z.literal('organization').optional(),
    leading: z.array(reactElementSchema).optional(),
  }),
});
